import memoize from 'memoizee'
import { isEmpty } from '../utils/common'

export const getSSDMetaData = memoize(state => {
  const { metaData } = state.settingsSSDMaterials
  return isEmpty(metaData) ? {} : metaData
})

export const getCurrentEducationPeriodCd = memoize(state => {
  const { current } = state.settingsEducationPeriod
  return current
})

export const getPreviousEducationPeriodCd = memoize(state => {
  const { previous } = state.settingsEducationPeriod
  return previous
})

export const getEducationPeriods = memoize(state => {
  const { availableEducationPeriods } = state.settingsEducationPeriod
  return availableEducationPeriods
})
